import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  contentBoxes: any[];
  counters: { label: string; value: number, current: number }[];
  counterOptions: any = {
    suffix: '+',
    duration: 3
  };

  constructor() {
  }

  ngOnInit(): void {
    this.counters = [
      {value: 4000000, label: 'יצוא רכבים שנתי מגרמניה ב2018', current: null},
      {value: 361000, label: 'כלי רכב חדשים בישראל ב2018', current: null},
      {value: 245000, label: 'כלי רכב מתוצרת גרמניה בישראל', current: null},
      {value: 85, label: 'אחוז הרכבים הפרטיים בישראל', current: null}
    ];

    // for (let counter of this.counters) {
    //   setInterval(() => {
    //     while (counter.current < counter.value) {
    //       counter.value++;
    //     }
    //   }, 50);
    // }
    this.contentBoxes = [
      {
        header: 'עוד סיבה טובה לבחור בSlickChain',
        content: 'SlickChain הוא פלטפורמה חדשנית לקבלת הערכת עלויות של יבוא, מיסוי ושחרור של רכבים.',
        image: '/assets/images/file.png',
        inView: false,
      },
      {
        header: 'המובילים המנוסים והמקצועיים ביותר',
        content: 'אנחנו עובדים עם משלחים ונותני שירותים מנוסים ומקצועיים מאוד שידאגו לשילוח הרכב שלכם באופן הטוב ביותר.',
        image: '/assets/images/file (1).png',
        inView: false,
      },
      {
        header: 'אנחנו נדע לתת לכם יכולת חישוב מיסי יבוא',
        content: 'מיסי יבוא על רכבים היא מטלה מורכבת ורגישה, SlickChain מציגה את המחשבון מיסים המקוון הראשון בישראל למכוניות.',
        image: '/assets/images/file (2).png',
        inView: false,
      }
    ];
  }

  inViewCounter($event: any) {
    if ($event.visible) {
      this.counters.map(c => {
        c.current = c.value;
      });
    }
  }

  cbInView($event, cb: any) {
    if ($event.visible) {
      cb.inView = true;
    }
  }
}
